import { Component,Input, OnDestroy, OnInit,  ViewChild ,ElementRef,AfterViewInit,ViewEncapsulation,isDevMode} from '@angular/core';
import { interval } from 'rxjs';

import { faCoffee, faHourglassEnd, faLessThanEqual } from '@fortawesome/free-solid-svg-icons';
import {faFileUpload} from '@fortawesome/free-solid-svg-icons';
import {faCloudUploadAlt} from '@fortawesome/free-solid-svg-icons';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {faSearch,faVideo,faArrowDown,faPlay} from '@fortawesome/free-solid-svg-icons';
import {faFileArchive} from '@fortawesome/free-solid-svg-icons';
import { KeycloakProfile } from 'keycloak-js';
import { KeycloakService } from 'keycloak-angular';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DownloaderService} from './services/downloader.service';
import videojs from 'video.js';
import { positionService } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import {PlayerComponent} from './player/player.component';
import { HttpEventType} from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  
  userDetails: KeycloakProfile;
  files=[]
  faCoffee = faCoffee;
  faSearch=faSearch;
  faFileUpload=faFileUpload;
  faCloudUploadAlt=faCloudUploadAlt;
  faFileArchive=faFileArchive;
  faTimes=faTimes;
  faVideo=faVideo;
  faPlay=faPlay;
  faArrowDown=faArrowDown;
  idCode=''
  closeResult = '';
  selectedFile={"formatted_name":" ","size": " "}
  lookedupFiles=[]
  signedURL=''
  videoPlayerTitle=''
  creatingZip=false
  downProgressPercentage='0'
  downProgressPercentageStyle='0%'
  downloadSpeed="0"
  downloadSpeeds=[0]
  currentSpeed=''
  lastNow = new Date().getTime();
  mostrarBotonDescargarTodo: boolean = true; 

  display: boolean = false;
  show_player=true

  docVidBorrado: boolean = false;
  shortIdDocVidInexistente: boolean = false;
  showDocVidData: boolean = false;


  val: number = 3;
  @ViewChild('target', {static: true}) target: ElementRef;

  @Input() options: {
    fluid: boolean,
    aspectRatio: string,
    autoplay: boolean,
    sources: {
        src: string,
        type: string,
    }[],
};
player: videojs.Player;
 
 // @ViewChild('ourForm', {static: true}) ourForm;
 ngAfterViewInit() {
  //
}
ngOnDestroy() {
  // destroy player
  if (this.player) {
    this.player.dispose();
  }
}



constructor(private keycloakService: KeycloakService,
  private modalService: NgbModal,
  private downloaderService: DownloaderService, private elementRef: ElementRef){}
  

open(content) {
  this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}

private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}

async doLogout() {
  await this.keycloakService.logout();
}




async ngOnInit()
{
  // this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
  //    if(isDevMode()) console.log('onPlayerReady', this);
  // }); 
   if(isDevMode()) console.log("actual url");
   if(isDevMode()) console.log('URL:' + window.location.href);
  const fullURL=window.location.href
  console.log("fullfull",fullURL)
  console.log (fullURL.split('cpl/'))
  console.log (fullURL.split('cpl/')[1].substring(0,10))
  let fullURLarr=fullURL.split('/')

  console.log("Full URL:", fullURL);
  const idCplMatch = fullURL.match(/cpl\/([A-Za-z0-9]+)/i);
  console.log("Match result:", idCplMatch);
  if (idCplMatch) {
    console.log("Captured ID:", idCplMatch[1]);
    this.idCode = idCplMatch[1];
    this.lookup(this.idCode);
  } else {
    console.log("No match found for 'cpl/'");
  }
 
  const shortID=fullURLarr
  // quitar a ShortID cpl
  
  const tenant=fullURLarr

   if(isDevMode()) console.log(shortID)

  
   if(isDevMode()) console.log('shortid'+shortID)
   if(isDevMode()) console.log("tenant"+tenant)

console.log ("TENATA"+tenant)
console.log ("SHORTID"+shortID)
 

//  si tenant y short id estan en la url, buscar el short id pero si no que no muestre nada 
if (shortID && tenant) {

  this.lookup(fullURL.split('cpl/')[1].substring(0,10));

  
}


if (tenant) {
  tenant[0] = tenant[0].replace('.cpl/', '');  
}


  if (await this.keycloakService.isLoggedIn()) {  
     if(isDevMode()) console.log("logged in!!");
    this.userDetails = await this.keycloakService.loadUserProfile();
  }
  if (this.lookedupFiles.length > 0) {
    this.mostrarBotonDescargarTodo = !this.lookedupFiles.some(file => file.tipo_archivo === 'video');}

//un if que sea si tiene videos no mostrar el boton de descargar todo


}
download_all(all)
{
  this.creatingZip=true
  let files_list=[]
  let obj={}
  // if(isDevMode()) console.log(all);
  
  for (let a = 0; a < all.length; a++) {
    obj={'bucket_name':all[a]['bucket'],'id_s3':all[a]['id_s3']}
    files_list.push(obj)
    
  }
   if(isDevMode()) console.log("BEFOIRE POST");
   if(isDevMode()) console.log(files_list);
  
  
  this.send_post(files_list)
}
setupvideo(vid)
{
  this.signedURL=''
  this.videoPlayerTitle=vid['archivo']
this.downloaderService.getVideoURL(vid['bucket'],vid['id_s3']).subscribe(r=>
  {
    this.show_player=true
    // if(isDevMode()) console.log('YEAA');
    
     if(isDevMode()) console.log(r['url_signed'])
    this.signedURL=r['url_signed']
    this.display = true;
    // if (this.player) {
    //   this.player.dispose();
    // }
   let options= { autoplay: true, controls: true, sources: [{ src: '/path/to/video.mp4', type: 'video/mp4' }]}
  options.sources=[{src:r['url_signed'],type:'video/mp4'}]
  
 
    // this.player = videojs(this.target.nativeElement, options, function onPlayerReady() {
    //    if(isDevMode()) console.log('onPlayerReady', this);
    // });
    
})
}

//cuando se suben videos opción de descarga
hayVideos(): boolean {
  return this.lookedupFiles.some(file => file.tipo_archivo === 'video');
}


showDialog() {
    this.display = true;
}
show_detail(f)
{
  f['fileName_without_under']=f['archivo'].replace(/_/g," ")
   if(isDevMode()) console.log(f)
  this.selectedFile=f

}
downloadSelected(file)
{
  this.selectedFile=file
  let files_list=[]
  let obj={}

  obj={'bucket_name':this.selectedFile['bucket'],'id_s3':this.selectedFile['id_s3']}
  files_list.push(obj)
  this.send_post(files_list)


}



launchSpeeder(bytes,total)
{

}



send_post(files_list)
{
  this.downloaderService.download({"files_list":files_list}).subscribe((r)=>
  {
    if (r.type === HttpEventType.DownloadProgress) {
      if(isDevMode()) console.log("download progress");
      //console.log(r.type)
      this.launchSpeeder(r.loaded,r.total)
      if(isDevMode()) console.log("SPEED", this.downloadSpeeds)
      this.downProgressPercentage=Math.trunc((r.loaded*100/r.total)).toString()

      this.downProgressPercentageStyle=this.downProgressPercentage+'%'
     // this.downloadSpeeds.push(r.loaded/r.total)

  }
  if (r.type === HttpEventType.Response) 
  {
      let typetemp='application/pdf'
    let fileName=this.selectedFile['archivo']

    if(files_list.length>1){typetemp='application/zip'}
    if(files_list.length>1){fileName='todos.zip'}
    const blob = new Blob([r['body']], { type: typetemp });
    const blobUrl = URL.createObjectURL(blob);
    // Create a link element
    const link = document.createElement("a");
    let name=fileName
    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = name;
    // Append link to the body
    document.body.appendChild(link);

    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
    new MouseEvent('click', { 
    bubbles: true, 
    cancelable: true, 
    view: window 
    })

    );

  // Remove link from body
  document.body.removeChild(link);

  }
   if(isDevMode()) console.log(r)


  


});
}

lookup(e)
{

  this.docVidBorrado = false;
  this.shortIdDocVidInexistente = false;
  this.showDocVidData = false;
  this.showDocVidData = true;

  this.creatingZip=false

  if (e !==undefined)
  {
    //fell here due to short id found on loading URL firsthand
    this.idCode=e 
    
  }
  
  this.idCode = this.idCode.replace('cpl/', '');
  if(isDevMode()) console.log("looking up")
  if(isDevMode()) console.log(this.idCode);
  if(isDevMode()) console.log("looking up")
 if(this.idCode.length>3)
 {
   
   let temps=this.idCode
  //  //
    if(isDevMode()) console.log("temps"+temps)
   if(true) //checking if prefix and short id are there
   
   {
     if(temps.length>8) //checking if short id is not empty
     {
       if(isDevMode()) console.log(" valid")
      this.downloaderService.verify(temps).subscribe(r=>
        {
           if(isDevMode()) console.log(r['data']['documento'])
          this.lookedupFiles=r['data']['documento']
        })
     }
      if(isDevMode()) console.log(temps);
      if(isDevMode()) console.log(temps.length>0);
         
    }
   
 }

  

  console.log("looking up")
  console.log(this.idCode);

  if(this.idCode.length>3)
  {
    let temps=this.idCode
    console.log("temps "+temps)
    if(temps.length==2) //checking if prefix and short id are there
    {
      if(temps.length>8) //checking if short id is not empty
      {
        console.log(" valid")
        this.downloaderService.verify(temps).subscribe(r=> {

          if (r['data']) {
            // si encuentro un doc/vid con el short_id dado

            console.log('---');
            console.log(r['data']['documento'])

            let docVidArray = r['data']['documento'];

            if (docVidArray.length == 1) {
              // si el shor_id dado solo trae un doc/vid

              if (docVidArray[0]['estado'] == 'activo') {
                // si el doc/vid esta activo
                this.lookedupFiles = docVidArray;
                this.showDocVidData = true;
              } else {
                // si el doc/vid esta borrado
                this.docVidBorrado = true;
              }
            } else {
              // si el shor_id dado trae n docs/vids, se ingreso un short_id de grupo

              console.log('length del array es n');

              let tmpArray = [];
              for (let i = 0; i < docVidArray.length; i++) {

                console.log('---');
                console.log(docVidArray[i].estado);

                if (docVidArray[i].estado == 'activo') {
                  tmpArray.push(docVidArray[i]);
                }
              }

              if (tmpArray.length == 0) {
                // si en el grupo no hay docs/vids activos
                this.docVidBorrado = true;
              } else {
                // si en el grupo hay al menos un doc/vid no borrado
                this.lookedupFiles = tmpArray;
                this.showDocVidData = true;
              }
            }
          } else {
            // si no encuentro un doc/vid con el short_id dado
            this.shortIdDocVidInexistente = true;
          }
        })
      } else {
        // si el length del short_id ingresado por el usuario es <= 8
        this.showDocVidData = false;
      }
      console.log(temps);
      
    }
  }
}



cutAndPrepare(fln) {
  let processed = ''
  let rest = ''
  let processed0 = ''
  let rest0 = ''
  let tail = ''
  let triple_dots = ''
  if (fln.length > 18) {
    processed = fln.slice(0, 18)
    rest = fln.slice(18, fln.length)
    if (rest.length > 18) {
      processed0 = rest.slice(0, 18)
      rest0 = rest.slice(18, rest.length)
    } else {
      rest0 = rest
    }

  } else {
    processed = fln
  }

  let dot_suspect = fln.slice(fln.length - 4, fln.length - 3)
  if (dot_suspect == '.') {

    if (rest0.length > 18) {
      tail = fln.slice(fln.length - 3, fln.length)
    }

  }

  if ((processed + ' ' + processed0 + ' ' + rest0).length > 54) triple_dots = '...'
  return ((processed + ' ' + processed0 + ' ' + rest0).slice(0, 54) + triple_dots + tail)
}



}
